import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const getLocalUser = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  return user;
};

const deleteLocalUser = () => {
  localStorage.removeItem("user");
};

const setLocalUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

axiosClient.interceptors.request.use(
  (config) => {
    const user = getLocalUser();

    if (user) {
      config.headers.Authorization = `Bearer ${user}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;

    if (error?.response) {
      if (error?.response?.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        deleteLocalUser();
        window.location.href = "/";
        return Promise.reject(error);
      }

      if (error?.response?.status === 403) {
        window.location.href = "/projects";
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export { axiosClient, deleteLocalUser, setLocalUser, getLocalUser };
